var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m4.817 10.75 4.212 4.189-1.058 1.063-5.5-5.471a.75.75 0 0 1 0-1.063l5.5-5.472L9.03 5.06 4.817 9.25H18v1.5z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }